import { useEffect, useState } from "react";
import { Reveal } from "./Reveal";
import { STATS, TESTIMONIALS } from "./data";

function Stats() {
  return (
    <section data-testid="stats-section" className="relative py-24 border-t border-white/5">
      <div className="mx-auto max-w-7xl px-6 lg:px-10 grid grid-cols-2 lg:grid-cols-4 gap-y-14 gap-x-8">
        {STATS.map((s, i) => (
          <Reveal key={s.label} delay={i * 0.1}>
            <div data-testid={`stat-${i}`} className="text-center lg:text-left">
              <p className="font-heading font-light text-5xl lg:text-6xl text-gold tracking-tight">{s.value}</p>
              <p className="mt-3 text-xs uppercase tracking-[0.2em] text-foreground/50">{s.label}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
}

function Testimonials() {
  const [i, setI] = useState(0);
  const [paused, setPaused] = useState(false);
  useEffect(() => {
    if (paused) return;
    const t = setInterval(() => setI((p) => (p + 1) % TESTIMONIALS.length), 6000);
    return () => clearInterval(t);
  }, [paused, i]);
  const active = TESTIMONIALS[i];

  const select = (idx) => {
    setI(idx);
    setPaused(true);
    setTimeout(() => setPaused(false), 12000);
  };

  return (
    <section data-testid="testimonials-section" className="relative py-28 lg:py-40 border-t border-white/5 overflow-hidden">
      <div className="absolute inset-0 bg-grain opacity-[0.03]" />
      <div className="relative mx-auto max-w-4xl px-6 lg:px-10 text-center">
        <Reveal>
          <p className="overline mb-10">In Their Words</p>
        </Reveal>
        <Reveal delay={0.1}>
          <blockquote
            key={i}
            data-testid="testimonial-quote"
            className="font-heading font-light text-3xl sm:text-4xl lg:text-5xl leading-[1.25] tracking-tight italic transition-opacity duration-700"
          >
            "{active.quote}"
          </blockquote>
        </Reveal>
        <Reveal delay={0.2}>
          <div className="mt-10">
            <p className="text-gold tracking-wide">{active.author}</p>
            <p className="text-sm text-foreground/50 mt-1">{active.role}</p>
          </div>
        </Reveal>

        <div className="mt-12 flex items-center justify-center gap-3">
          {TESTIMONIALS.map((_, idx) => (
            <button
              key={idx}
              data-testid={`testimonial-dot-${idx}`}
              onClick={() => select(idx)}
              aria-label={`Testimonial ${idx + 1}`}
              className={`h-1.5 rounded-full transition-all duration-500 ${
                idx === i ? "w-8 bg-gold" : "w-1.5 bg-foreground/25 hover:bg-foreground/50"
              }`}
            />
          ))}
        </div>
      </div>
    </section>
  );
}

export { Stats, Testimonials };
